<template>
  <div class="act">
    <!-- <img 
      src="@/assets/GuangzhouUnicomImg/new2/bg.png"
      class="act-bg"
      alt=""
    />
     -->
    <LogoHeader :logoPath="require('@/assets/logo/elm/elm-telecom.png')"
    altText="中国电信"/>
    <img
      class="queryBtn"
      src="@/assets/GuangzhouUnicomImg/queryBtn.png"
      alt=""
      @click="queryOrder"
    />
    <img
      class="kefuBtn"
      src="@/assets/GuangzhouUnicomImg/service.png"
      alt=""
      @click="openKefu"
    />
    <div class="bottomBtn" v-show="bottomBtn">
      <img
        @click="onSubmit"
        class="bottomBtnImg"
        src="@/assets/GuangzhouUnicomImg/lqBtn.png"
        alt=""
      />
    </div>
    <div class="content">
      <img src="@/assets/dxtop.png" class="topImg" alt="" />
      <div class="contentBox1">

        <div class="container">
          <div class="header">套餐内容</div>
          <div class="content">
            <div class="zfxqTable3">
              <div class="titleBox" style="font-size: 18px; color: #3e5fb2; font-weight: bold; margin-bottom: 8px;">蜂鸟骑手团购专享，仅限骑手办理</div>
              <table style="width:100%;border-collapse:collapse;table-layout:fixed;">
                <colgroup>
                  <col style="width: 25%;" />
                  <col style="width: 25%;" />
                  <col style="width: 25%;" />
                  <col style="width: 25%;" />
                </colgroup>
                <tr>
                  <th class="zTh">套餐资费</th>
                  <th class="zTh">39元/月</th>
                  <th class="zTh">49元/月</th>
                  <th class="zTh">59元/月</th>
                </tr>
                <tr>
                  <th class="zTh">月费<br/>
                    <span style="font-size: 11px;">(首月0.1元)</span><br>
                    <span class="small" style="color:red">仅限激活当个自然月，非30天，例：25日激活，用到月底仅0.1元</span>
                  </th>
                  <td class="zTd">39元/月</td>
                  <td class="zTd">49元/月</td>
                  <td class="zTd">59元/月</td>
                </tr>
                <tr>
                  <th class="zTh">语音</th>
                  <td class="zTd">1500分钟</td>
                  <td class="zTd">2000分钟</td>
                  <td class="zTd">2000分钟</td>
                </tr>
                <tr>
                  <th class="zTh">流量<br/>（通用流量）</th>
                  <td class="zTd">240G</td>
                  <td class="zTd">270G</td>
                  <td class="zTd">290G</td>
                </tr>
                <tr>
                  <th class="zTh">套外资费</th>
                  <td class="zTd left" colspan="3">
                    <div class="blueText pBottom">国内语音：0.15元/分钟</div>
                    <div class="pBottom">
                      <span class="blueText">国内流量：3元/GB</span>
                      <span class="small">（即:前100MB按0.03元/MB收费，达到100MB（3元）时，额外赠送用户924MB流量（即3元/1GB）;超过1GB的,仍按上述原则(即每1GB收费3元)收费，以此类推。）</span>
                    </div>
                    <div class="blueText">国内短彩信：0.1元/条</div>
                  </td>
                </tr>
              </table>
            </div>
          </div>

        </div>
      </div>
      <div class="contentBox2">
        <div class="userInfo">
          <van-form @submit="onSubmit" :label-width="0">
            <div class="form-item">
              <div class="form-label form-label__reqiured">套餐</div>
              <van-field
                class="form-field"
                v-model="comboName"
                name="cardName"
                placeholder="请选择套餐"
                readonly
                @click="showTCBox"
              />
              <van-popup v-model="tcShow" position="bottom">
                <div class="tcBox">
                  <div class="topBox">
                    <!-- <div class="close" @click="closeTC">取消</div>
                    <div class="define" @click="defineTC">确定</div> -->
                    <van-icon name="cross" size="24px" color="#999" @click="closeTC"/>
                  </div>
                  <div class="content">
                    <div
                      :class="['tcItem', { active: index == selIndex }]"
                      v-for="(item, index) in tcList"
                      :key="index"
                      @click="changeTC(index)"
                    >
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </van-popup>
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">姓名</div>
              <van-field
                class="form-field"
                v-model="cardName"
                name="cardName"
                placeholder="与身份证一致（已加密）"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">身份证号</div>
              <van-field
                class="form-field"
                v-model="cardNo"
                name="cardNo"
                maxlength="18"
                placeholder="仅用于本次业务（已加密）"
                :rules="[
                  {
                    validator: sfzValidator,
                    message: '请输入正确身份证号码',
                  },
                ]"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">联系电话</div>
              <van-field
                class="form-field"
                v-model="contactsMobile"
                maxlength="11"
                name="contactsMobile"
                placeholder="收货手机号码（已加密）"
                :rules="[{ pattern, message: '请输入正确手机号码' }]"
              />
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">号码归属地</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="cardAttribution"
                :value="cardAttribution"
                placeholder="请选择归属地区省市"
              />
              <!-- <van-popup v-model="showPicker" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="areaList2"
                  @confirm="selectCity"
                />
              </van-popup> -->
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">收货城市</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="contactsCity"
                :value="contactsCity"
                placeholder="请选择收货区省市"
                @click="showArea = true"
              />
              <van-popup v-model="showArea" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="areaList"
                  @confirm="onConfirm"
                />
              </van-popup>
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">详细地址</div>
              <van-field
                class="form-field"
                v-model="contactsAddress"
                name="contactsAddress"
                placeholder="街道小区门牌号等(无需重复省市区)"
              />
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">免费选号</div>
              <!-- <span style="padding-right:15px">随机号码</span> -->
              <van-field
                readonly
                clickable
                class="form-field"
                :value="comboMobile"
                name="comboMobile"
                placeholder="请选择号码"
                @click="numGuessSelect()"
              />
              <van-dialog
                v-model="showMobilePicker"
                :showConfirmButton="false"
                class="numDialog"
              >
                <div class="numClose">
                  <van-icon
                    name="close"
                    @click="showMobilePicker = false"
                    size="1.2rem"
                  />
                </div>
                <div class="numBox">
                  <div
                    v-for="item in numList"
                    :key="item"
                    class="numContent"
                    @click="selcetNum(item)"
                  >
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="numBtn">
                  <van-button
                    icon="replay"
                    type="default"
                    native-type="button"
                    @click="numGuessSelect()"
                    >换一换</van-button
                  >
                </div>
              </van-dialog>
            </div>

            <div class="form-item" v-if="false">
<!--              <div class="form-label form-label__reqiured">身份证明</div>-->
              <div class="upload-container">
                <div class="upload-item">
                  <van-uploader v-model="proofImage" :after-read="onProofImageRead" :max-count="1">
                    <template #upload>
                      <div class="upload-trigger">
                        <van-icon name="plus" size="24px" color="#999" />
                      </div>
                    </template>
                  </van-uploader>
                  <div class="upload-tip" v-show="!proofImage || proofImage.length === 0">点击上传</div>
                </div>
                <div class="upload-item example" @click="showExample('proof')">
                  <div class="example-img-wrapper">
                    <img src="@/assets/elm/qszm.jpg" class="example-img" alt="示例" />
                  </div>
                  <div class="upload-tip">查看示例</div>
                </div>
              </div>
            </div>
            <div class="form-item" v-if="false">
              <div class="proof-desc">
                <p>*上传截图要求：</p>
                <p class="blue-text">蜂鸟众包/蜂鸟骑士APP-个人中心（要有姓名和跑单量信息）</p>
                <p class="red-text">*本号卡为蜂鸟骑手团购卡，请骑手正常跑单后再下单。</p>
              </div>
            </div>


            <div class="form-item" v-if="zpActivety">
              <div class="form-label form-label__reqiured">
                {{ simSpiActivity.giftAttrName }}
              </div>
              <van-field
                v-if="sizeList.length <= 1"
                class="form-field"
                :value="giftInfo"
                name="contactsAddress"
                placeholder="请选择赠品尺码"
              />
              <select
                v-else
                class="selectBox"
                v-model="giftInfo"
                @change="changeSize"
              >
                <option value="" disabled selected>请选择尺码</option>
                <option v-for="(item, index) in sizeList" :key="index">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="activeInfo" v-if="zpActivety">
              <div class="activeLeft">{{ simSpiActivity.tips }}</div>
              <div class="activeRight" @click="openTips">
                活动说明
                <van-icon name="question-o" />
              </div>
            </div>
            <div
              class="dealText"
              v-if="dealTextList && dealTextList.length > 0"
            >
              <div class="read">
                <van-checkbox v-model="checkDeal" icon-size="16px" />
                我已阅读并同意
                <span
                  class="deal"
                  @click="toUnicomDeal(item.components)"
                  v-for="(item, index) in dealTextList"
                  :key="index"
                  ><span class="xy">《{{ item.name }}》</span>
                  <!-- {{ index == dealTextList.length - 1 ? "" : "、" }} -->
                </span>
              </div>
            </div>
          </van-form>
          <div class="btn" ref="sumitBtm" @click="onSubmit">
            <img
              class="lqBtn"
              src="@/assets/GuangzhouUnicomImg/lqBtn.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="contentBox1">
        <div class="bmInfo">
          <div class="bmTitle">最新报名用户</div>
          <div class="bmContent">
            <vue-seamless-scroll
              class="scroll-content"
              :class-option="classOption"
              :data="winningList"
            >
              <div
                class="bmItem"
                v-for="(item, index) in winningList"
                :key="index"
              >
                <div class="bmItemName">{{ item.name }}</div>
                <div class="bmItemPhone">{{ item.phone }}</div>
                <div class="bmItemTime">{{ item.time }}分钟前</div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
        <!-- <div class="tcysInfo">
          <img
            class="tcysImg"
            src="@/assets/GuangzhouUnicomImg/new2/tcys.png"
            alt=""
          />
        </div> -->

        <div class="container">
          <div class="header">资费详情</div>
          <div class="content">
            <div class="section">
              <h3>详细说明：</h3>
              <p>1.首月0.1元 <span style="color:red">(仅限激活当个自然月，非30天，例：25日激活，用到月底仅0.1元) </span><strong style="font-family: SimHei, '黑体', sans-serif; font-size: 14px; font-weight: bold;">（激活需首充100元话费）</strong></p>
              <p>语音及流量按激活日期折算(当月剩余天数/当月总天数);如语音流量不超出资费内容，则首月月租0.1元。</p>
              <p>
                2.套餐的语音与流量均不可结转。
              </p>
              <p>
                3.套餐外计费规则:
              </p>
              <p>
                （1）套外流量：前100MB按0.03元/MB收费，达到100MB（3元）时，额外赠送用户924MB流量（即3元/1GB）;流量超过1GB时，仍按上述原则（即每超出1GB按照3元/1GB收费）收费，以此类推。<br>
                （2）套外语音：当月国内通话超出对应套餐档位所包含分钟数后，按国内0.15元/分钟计收，不足1分钟按1分钟计。<br>
                （3）国内短/彩信：0.1元/条
              </p>
             <p>4.国内流量适用范围：手机上网流量仅限中国大陆境内使用，可用于中国电信现有移动通信网络，不含WLAN（Wi-Fi）上网</p>
              <p>
                5.以上内容不含国际及中国港澳台地区。
              </p>
<!--              <p>6.套餐资费长期有效。全国接听免费，赠送来电显示、天翼云盘-免费版、189邮箱-免费版。</p>-->
              <p>
                <strong>6.更多详情请咨询页面专属客服或电信营业厅。</strong>
              </p>
              <p>7.本产品仅限蜂鸟骑手员工团购。</p>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="header">其他说明</div>
          <div class="content">
            <div class="section">
              <p>1、套餐变更、退订，次月生效。</p>
              <p>
                2、套餐中的"国内"指中国内地，不含港澳台地区。(下同)套餐中包含的语音通话分钟数、短/彩信及手机上网流量仅限中国内地使用，手机上网流量只适用于5G、4G、3G、2G，不区分5G、4G、3G、2G，不含WLAN(Wi-Fi)上网。(下同)。
              </p>
              <p>
                3、套餐内包含的以及赠送的国内通信费不含信息费等代收费。(下同)
              </p>
              <p>
                4、上网当月套餐外流量消费600元及600元的倍数则断网，次月初自动开通，如果客户当月申请继续使用，则继续提供服务，按照套外资费收费。
              </p>
              <p>
                5、本套餐所含定向流量为中国电信联合合作方提供，若合作关系发生变化，中国电信有权对相关内容进行调整或停止提供。若用户不同意调整，可申请终止服务协议。该套餐只限新入网用户办理。
              </p>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="header">常见问题</div>
          <div class="content">
            <div class="section">
              <p>1、未满20周岁不能办理新卡入网。</p>
              <p>
                2、请于提交订单15天内激活您的号卡，逾期未能激活的，本订单将自动取消，号卡失效。
              </p>
              <p>
                3、根据工信部要求，您的号卡激活且开通后将由人工对实名照片进行审核，审核不通过的将通过短信方式通知您按要求进行补上传照片操作，逾期若未补上传照片的，号码将被暂停通信服务。
              </p>
              <p>4、50天内已超过3次办理移动号卡拆机业务的用户无法办理此卡。</p>
              <p>5、本套餐不支持副卡。</p>
              <p class="textIndent">套餐条款以页面营销协议为准</p>
              <p>
                6、此卡禁止用于电话销售/推销/金融等类似骚扰诈骗等形式的用途，一旦被投诉或系统监测到会导致停机，无法继续享受优惠或使用。
              </p>
              <p>
                7、产品及相关优惠活动仅限指定互联网渠道销售，产品最终名称以电信系统展示为准。在使用过程中若遇任何问题，可致电18594033399/17502020112客服热线咨询。
              </p>
            </div>
          </div>
        </div>
      </div>

      <img
        class="bottomImg"
        src="@/assets/GuangzhouUnicomImg/bottomImg.png"
        alt=""
      />
    </div>
    <van-dialog
      v-model="showKefu"
      title="扫码联系客服"
      confirm-button-text="关闭"
      confirm-button-color="#3860cf"
    >
      <div class="kefuBox">
        <!-- <img
          class="kefuQRCode"
          src="@/assets/GuangzhouUnicomImg/new/kefuQRCode.png"
          alt=""
        /> -->
      </div>
    </van-dialog>
    <van-dialog
      v-model="showSetSize"
      title="赠品尺码"
      confirm-button-text="确定"
      confirm-button-color="#3860cf"
      @confirm="confirmSize"
    >
      <div class="sizeBox">
        <div class="sizeBoxList">
          <div
            :class="['sItem', { active: index == sizeIndex }]"
            @click="changeSize(index)"
            v-for="(item, index) in sizeList"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="tipsShow"
      confirm-button-text="关闭"
      confirm-button-color="#3860cf"
      @confirm="closeTips"
    >
      <div class="dialogTips">
        <img class="tipsImg" :src="tipsImg" alt="" />
      </div>
    </van-dialog>
    <dialogTips
      :text="dialogTips.text"
      :icon="dialogTips.icon"
      :iconColor="dialogTips.iconColor"
      :show="dialogTips.show"
      :confirmButtonText="dialogTips.confirmButtonText"
      @confirm="confirmTips"
    ></dialogTips>

    <van-dialog
      v-model="exampleDialogShow"
      title="示例"
      confirm-button-text="关闭"
      confirm-button-color="#3860cf"
    >
      <div class="example-dialog-img" v-if="exampleImgSrc">
        <img :src="exampleImgSrc" alt="示例" />
      </div>
    </van-dialog>

    <!-- 添加升级提示弹窗 -->
    <van-dialog
      v-model="showUpgradeDialog"
      :show-confirm-button="false"
      :close-on-click-overlay="false"
      :show-cancel-button="false"
      class="upgrade-dialog"
    >
      <div class="upgrade-content">
        <div class="upgrade-icon">
          <van-icon name="warning" size="48" color="#ff9500" />
        </div>
        <h3 class="upgrade-title">系统升级维护中</h3>
        <p class="upgrade-message">尊敬的用户：</p>
        <p class="upgrade-message">系统正在进行临时升级维护</p>
        <p class="upgrade-message">暂停下单服务</p>
        <!-- <p class="upgrade-time">预计恢复时间：2024-12-25 18:00</p> -->
        <van-button 
          type="primary" 
          block 
          class="upgrade-btn"
          @click="showUpgradeDialog = false"
        >
          我知道了
        </van-button>
      </div>
    </van-dialog>
    <!-- 半透明套餐快捷按钮 -->
    <!-- <div class="package-btns">
      <a
        class="pkg-btn"
        href="https://txwk.10010.com/kcardorder/gotoUid?state=KCARD_WKPEN_COMMOM_ORDERLAND&pageKey=db1edd8AFe&channel=09-2279-bpo9-c5dx&ADTAG=09-2279-bpo9-c5dx"
      >
        38元套餐
      </a>
      <a
        class="pkg-btn"
        href="https://txwk.10010.com/kcardorder/gotoUid?state=KCARD_WKPEN_COMMOM_ORDERLAND&pageKey=a81572C3F4&channel=09-2279-bpo9-c5dx&ADTAG=09-2279-bpo9-c5dx"
      >
        58元套餐
      </a>
    </div> -->
  </div>
</template>

<script>
import {
  Form,
  Field,
  Popup,
  Picker,
  Dialog,
  Icon,
  Checkbox,
  Button,
  Uploader,
} from "vant";
// import areaData from "../../public/static/areaData-gz-telecom.json";
//发货地改回广东
import areaData from "../../public/static/areaData.json";
//import operatorData from "../../public/static/operatorData.json";
import { http } from "@/api/http";
import moment from "moment";
import dialogTips from "@/pages/components/dialogTips";
import LogoHeader from "@/components/LogoHeader.vue";
// import Countdown from "./components/Countdown.vue";
// import { deepClone } from "@/utils/utils";
export default {
  name: "GuangzhouUnicom2",
  components: {
    vanForm: Form,
    vanField: Field,
    vanPopup: Popup,
    vanPicker: Picker,
    vanButton: Button,
    vanIcon: Icon,
    vanCheckbox: Checkbox,
    vanUploader: Uploader,
    [Dialog.Component.name]: Dialog.Component,
    dialogTips,
    LogoHeader,
    // Countdown,
  },
  data() {
    return {
      areaList: [],
      comboName: "",
      cardName: "",
      cardNo: "",
      contactsMobile: "",
      cardAttribution: "",
      cardAttributionCode: "",
      comboMobile: "",
      contactsCity: "",
      contactsAddress: "",
      columns: [],
      showArea: false,
      showMobile: "",
      checkDeal: true,
      showPicker: false,
      // mapData: [],
      mtBmUid: "",
      spiId: "",
      cardAttributionProvince: "",
      showMobilePicker: false,
      numList: [],
      pattern: /^1[3456789]\d{9}$/,
      // selectCombo: {},
      goodsCode: null,
      dealTextList: [], //协议数据
      areaData: {},
      areaData2: {}, //号码归属地
      areaList2: [], //号码归属地选择列表
      saleId: null,
      scrollY: 0,
      bottomBtn: false,
      showBtnTop: 0,
      oIndex: 0,
      comboData: {},
      channel: "",
      winningList: [
        { name: "张**", phone: "137******3", time: 5 },
        { name: "李**", phone: "138******6", time: 7 },
        { name: "欧阳**", phone: "170******1", time: 7 },
        { name: "陈**", phone: "182******6", time: 9 },
        { name: "林**", phone: "187******3", time: 10 },
        { name: "张**", phone: "153******2", time: 10 },
        { name: "黄**", phone: "138******5", time: 11 },
        { name: "王**", phone: "136******1", time: 12 },
        { name: "李**", phone: "182******7", time: 12 },
        { name: "陈**", phone: "189******8", time: 13 },

        // 更多中奖者...
      ],
      classOption: {
        singleHeight: 40,
        waitTime: 5000,
      },
      showKefu: false,
      endTime: moment("2024/12/25 09:59:59").valueOf(),
      isEnded: false,
      sizeList: [],
      showSetSize: false,
      giftInfo: "",
      sizeIndex: 0,
      zpActivety: false,
      simSpiActivity: null,
      tipsShow: false,
      tipsImg: "",
      dialogTips: {
        text: "",
        icon: "",
        iconColor: "",
        show: false,
        confirmButtonText: "",
      },
      noClick: false,
      goodsName: "",
      selNumTips: "请选择号码",
      tcShow: false,
      selIndex: -1,
      tcList: [
        {
          name: "39元/月骑手团购卡",
          title: "GZDX-XXSL39",
          comboCode: "GZDX-XXSL39",
          goodsCode: "GZDX-XXSL39",
          price: 39,
        },
        {
          name: "49元/月骑手团购卡",
          title: "GZDX-XXSL49",
          comboCode: "GZDX-XXSL49",
          goodsCode: "GZDX-XXSL49",
          price: 49,
        },
        {
          name: "59元/月骑手团购卡",
          title: "GZDX-XXSL59",
          comboCode: "GZDX-XXSL59",
          goodsCode: "GZDX-XXSL59",
          price: 59,
        }
      ],
      comboCode: "",
      showUpgradeDialog: false,
      exampleImgSrc: "",
      exampleDialogShow: false
    };
  },
  created() {
    this.mtBmUid = localStorage.getItem("mtBmUid");
    this.spiId = localStorage.getItem("gysCode");
    this.saleId = localStorage.getItem("saleId");
    this.oIndex = localStorage.getItem("oIndex");
    this.channel = localStorage.getItem("channel");
    this.areaList = [];
    this.areaList.push(areaData["440000"]);
    //全国
    // this.areaList.push(areaData);
    // this.initAreaList2();
    this.cardAttribution = "广东广州";
    this.cardAttributionProvince = "440000";
    this.cardAttributionCode = "440100";
    // this.comboData = {
    //   comboLevel: 39,
    //   abstractImg: "",
    //   comboName: "骑手团购卡",
    //   showMobile: "true",
    //   goodsCode: this.oIndex,
    //   comboCode: this.oIndex,
    // };

    // this.comboName = this.comboData.comboName;
    // this.goodsName = this.comboData.comboName;
    // this.dealTextList = [
    //   {
    //     name: "入网协议",
    //     components: "unicomDeal9",
    //   },
    //   {
    //     name: "用户隐私协议",
    //     components: "ysxy",
    //   },
    // ];
    this.simViewLogAdd();
    this.getActivityBySpi();
  },
  watch: {
    selIndex(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.comboMobile = "";
        this.comboName = this.tcList[newVal].name;
        this.goodsName = this.tcList[newVal].name;
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      const height = this.$refs.sumitBtm.offsetTop;
      this.showBtnTop = height + window.innerHeight;
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    showExample(type) {
      if (type === "proof") {
        this.exampleImgSrc = require('@/assets/elm/qszm.jpg');
      }
      this.exampleDialogShow = true;
    },
    changeTC(index) {
      this.selIndex = index;
      this.tcShow = false;
    },
    showTCBox() {
      this.tcShow = true;
    },
  
    closeTC() {
      this.tcShow = false;
    },
    confirmTips() {
      this.dialogTips.show = false;
      this.$forceUpdate();
      if (this.dialogTips.icon == "success") {
        window.location.reload();
      }
    },
    openTips() {
      this.tipsImg = this.simSpiActivity.imgPath;
      // console.log("tipsImg =>",this.tipsImg)
      this.tipsShow = true;
    },
    closeTips() {
      this.tipsShow = false;
    },
    async simViewLogAdd() {
      let params = {
        mtBmUid: "GZTelecom39",
        spiId: this.spiId,
        clickName: "GZTelecom39",
        uid: "",
      };
      http("simViewLogAdd", params);
    },
    errorAdd(msg, remark, params) {
      let newParams = {
        mtBmUid: "GZTelecom39",
        spiId: this.spiId,
        clickName: `ERROR-GZTelecom39-${msg}`,
        uid: params.contactsMobile,
        remark,
        param: JSON.stringify(params),
      };
      http("simViewLogAdd", newParams);
    },
    confirmSize() {
      this.giftInfo = this.sizeList[this.sizeIndex].value;
    },
    setSize(item) {
      this.giftInfo = item.value;
    },
    changeSize(e) {
      console.log("e =>", e.target.value);
      this.giftInfo = e.target.value;
      // this.sizeIndex = index;
    },
    openSetMeal() {
      this.showSetSize = true;
    },
    ended() {
      this.isEnded = true;
    },
    openKefu() {
      // this.showKefu = true;
      window.location.href =
        "https://work.weixin.qq.com/kfid/kfc2ef46aff0a7d85a6";
    },
    queryOrder() {
      // window.location.href =
      // "https://m.10010.com/myorder/?isNew=1&entrycode=W002";
      this.$router.push({
        name: "OrderList",
      });
    },
    async getActivityBySpi() {
      let params = {
        spiId: this.spiId,
      };

      const res = await http("getActivityBySpi", params, { hideLoading: true });
      console.log("res=>", res);
      if (res && res.code == 200 && res.result.hasActivity) {
        let list = [];
        let sList = JSON.parse(res.result.simSpiActivity.giftSelectList);
        let obj = null;
        sList.map((v) => {
          for (let key in v) {
            obj = {
              name: key,
              value: v[key],
            };
          }
          list.push(obj);
        });
        if (list.length <= 1) {
          this.giftInfo = list[0].value;
        }
        this.sizeList = list;
        this.simSpiActivity = res.result.simSpiActivity;
        this.zpActivety = true;
        this.tipsImg = res.result.simSpiActivity.imgAlertPath;
        this.tipsShow = true;
      } else {
        this.zpActivety = false;
      }
    },
    async onSubmit(values) {
      //号码随机
      //this.comboMobile = "random";

      if (this.noClick) {
        return;
      } else if (!this.checkDeal) {
        this.$toast("请阅读并同意协议");
        return;
      } else if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      } else if (!this.comboMobile) {
        this.$toast("请选择号码");
        return;
      } else if (!this.contactsCity) {
        this.$toast("请选择收货区地址");
        return;
      } else if (!this.contactsAddress) {
        this.$toast("请输入详细的收货地址");
        return;
      } else if (this.contactsAddress.replace(/[^\u4e00-\u9fa5]/g, '').length < 5) {
        this.$toast("详细地址不能少于5位中文字符");
        return;
      } else if (this.zpActivety && !this.giftInfo) {
        this.$toast("请选择赠品尺码");
        return;
      }
      // else if (!this.proofImageBase64) {
      //   this.$toast("请上传跑单证明");
      //   return;
      // }

      //判断地址是否包含了省或市或区，如果包含，则提示不能包含省市区
      // 判断是否以省名称开头
      if (this.contactsAddress.startsWith(this.areaData.pName) ) {
        this.$toast("详细地址不能包含省市区");
        return;
      }
      // 去掉"市"字后匹配地市名称
      //if (this.contactsAddress.includes(this.areaData.cName.slice(0, -1))) {
      if (this.contactsAddress.includes(this.areaData.cName)) {
        this.$toast("详细地址不能包含省市区");
        return;
      }
      // 去掉"区"字后匹配区县名称
      //if (this.contactsAddress.includes(this.areaData.aName.slice(0, -1))) {
      if (this.contactsAddress.includes(this.areaData.aName)) {
        this.$toast("详细地址不能包含省市区");
        return;
      }
      let params = {
        comboLevel: this.tcList[this.selIndex].price,
        comboName: this.tcList[this.selIndex].name,
        cardAttribution: this.cardAttributionCode,
        goodsName: this.goodsName,
        mtBmUid: this.mtBmUid,
        spiDepartId: this.spiId,
        comboMobile: this.comboMobile,
        cardAttributionProvince: this.cardAttributionProvince,
        contactsProvince: this.areaData.pName, // 省
        contactsProvinceCode: this.areaData.pCode, // 省
        contactsCity: this.areaData.cName, // 市
        contactsCityCode: this.areaData.cCode, // 市
        contactsArea: this.areaData.aName, // 区
        contactsAreaCode: this.areaData.aCode, // 区
        comboCode: this.tcList[this.selIndex].comboCode,
        goodsCode: this.tcList[this.selIndex].goodsCode,
        saleId: this.saleId,
        cardName: this.cardName,
        cardNo: this.cardNo,
        channelCode: "",
        checkCode: "",
        contactsAddress: this.contactsAddress,
        contactsMobile: this.contactsMobile,
        //proofImage: this.proofImageBase64,
        proofImage: "",
        feeType: "",
        numberId: "",
        registerMobile: "",
        tractAddress: "",
        uid: "",
        channel: this.channel,
      };
      // if (this.areaData2.pCode != this.areaData.pCode) {
      //   this.errorAdd("GSDSHDZBYZ", "号码归属省份和收货省份不一致", params);
      //   return this.$toast("号码归属省份需和收货省份一致");
      // }
      if (this.zpActivety) {
        params = {
          ...params,
          giftInfo: this.giftInfo,
        };
      }
      this.noClick = true;
      let paramsData = Object.assign(values, params);
      const { code, message } = await http("simOrder", paramsData);
      this.noClick = false;
      if (code == 200) {
        this.dialogTips = {
          text: "提交成功，请留意快递信息，收到的手机号必须与您选择的号码一致，不一致将无法享受套餐相应优惠或活动赠送礼品，如发现号码不一致，请立即联系在线客服处理",
          icon: "success",
          iconColor: "#07C160",
          show: true,
          confirmButtonText: "确定",
        };
      } else {
        this.dialogTips = {
          text: message,
          icon: "warning",
          iconColor: "#FF4444",
          show: true,
          confirmButtonText: "关闭",
        };
      }
    },
    handleScroll() {
      this.scrollY = window.scrollY;
      if (this.scrollY >= this.showBtnTop) {
        if (!this.bottomBtn) {
          this.bottomBtn = true;
        }
      } else {
        if (this.bottomBtn) {
          this.bottomBtn = false;
        }
      }
      // console.log("Scroll Y position:", this.scrollY);
    },
    selcetNum(item) {
      this.comboMobile = item;
      this.showMobilePicker = false;
    },
    selectCity(values, indexs) {
      // console.log("value =>",value)
      // this.cardAttribution = value.text;
      // this.cardAttributionProvince = value.value;

      this.areaData2 = {
        pName:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
      };
      this.cardAttribution = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");
      this.showPicker = false;
    },
    onConfirm(values, indexs) {
      this.areaData = {
        pName:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
        aName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].text
            : "", //区
        aCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].code
            : "",
      };
      console.log("areaData =>", this.areaData);
      this.contactsCity = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");
      // this.mapData = values;
      this.showArea = false;
    },
    sfzValidator(val) {
      return /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
        val
      );
    },

    async numGuessSelect() {
      if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.contactsCity) {
        this.$toast("请选择收货地址");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      }

      console.log("spiId:", this.spiId);

      let params = {
        spiId: this.spiId,
        cityCode: this.cardAttributionCode,
        goodsId: this.tcList[this.selIndex].comboCode,
        provinceCode: this.cardAttributionProvince,
      };
      const { code, result, message } = await http(
        "ltZOPnumGuessSelect2",
        params
      );
      if (code !== 200) return this.$toast(message);
      if (code == 200) {
        console.log("result =>", result);
        this.numList = result;
        this.showMobilePicker = true;
      }
    },
    initAreaList2() {
      let pArr = [];
      let cArr = [];
      let pObj = {};
      let cObj = {};
      let areaList = [];
      areaList.push(areaData["440100"]);
      // areaList.push(areaData["c5ae2ee23e66400cac01eff3246498dd2"]);
      areaList.map((v) => {
        v.children.map((val) => {
          cArr = [];
          val.children.map((value) => {
            cObj = {
              text: value.text,
              code: value.code,
            };
            cArr.push(cObj);
          });
          pObj = {
            text: val.text,
            code: val.code,
            children: cArr,
          };
          pArr.push(pObj);
        });
      });
      console.log("pArr =>", pArr);
      this.areaList2 = [
        {
          text: "",
          code: "0",
          children: pArr,
        },
      ];
    },
    toUnicomDeal(components) {
      this.$router.push({
        name: components,
      });
    },
    getCard() {
      const queryData = Object.assign({}, this.swiperMsg, {
        spiId: this.spiId,
        mtBmUid: this.mtBmUid,
      });
      delete queryData.abstractImg;
      this.$router.push({
        name: "GuangzhouUHanding",
        query: queryData,
      });
    },
    async onProofImageRead(file) {
      console.log("file =>", file);
      let base64 = await this.compressAndGetBase64(file.file);
      console.log("proofImageBase64 =>", base64);
      this.proofImageBase64 = base64;
    },
    compressAndGetBase64(file, maxWidth = 500, quality = 0.7) {
      return new Promise((resolve, reject) => {
        if (typeof file === 'string' && file.startsWith('data:image')) {
          console.log("resolve...........")
          resolve(file);
          return;
        }
        console.log("压缩图片...........")
        const reader = new FileReader();
        reader.onload = e => {
          const img = new window.Image();
          img.onload = () => {
            let w = img.width;
            let h = img.height;
            if (w > maxWidth) {
              h = h * (maxWidth / w);
              w = maxWidth;
            }
            const canvas = document.createElement('canvas');
            canvas.width = w;
            canvas.height = h;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, w, h);
            // 动态获取图片类型
            const mimeType = 'image/jpeg';
            const base64 = canvas.toDataURL(mimeType, quality);
            resolve(base64);
          };
          img.onerror = reject;
          img.src = e.target.result;
        };
        reader.onerror = reject;
        if (file instanceof File) {
          reader.readAsDataURL(file);
        } else {
          reject('不支持的文件类型');
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/style/GuangzhouUnicom.less";
.small {
  font-size: 10px;
  // color: #999;
}
.pBottom {
  padding-bottom: 3px;
}
.textIndent {
  padding-left: 10px;
}

.upload-container {
  display: flex;
  gap: 24px;
  align-items: center;
  margin-top: 12px;
  justify-content: flex-start;
  margin-left: -5px;
  min-height: 160px;
}

.upload-item {
  width: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.upload-item.example {
  cursor: pointer;
}

.example-img-wrapper {
  width: 140px;
  height: 280px;
  border: 1px dashed #ccc;
  border-radius: 8px;
  overflow: hidden;
  background: #f7f8fa;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.example-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.example-dialog-img {
  text-align: center;
  padding: 20px 0;
}

.example-dialog-img img {
  width: 80%;
  display: inline-block;
  border-radius: 8px;
}

/* 统一 van-uploader 的大小 */
:deep(.van-uploader__upload) {
  width: 220px !important;
  height: 220px !important;
  margin: 0 !important;
  border-radius: 8px !important;
}

:deep(.van-uploader__preview),
:deep(.van-uploader__preview-image) {
  width: 220px !important;
  height: 220px !important;
  margin: 0 !important;
  border-radius: 8px !important;
}

.upload-trigger {
  width: 220px;
  height: 220px;
  border: 1px dashed #ccc;
  border-radius: 8px;
  background: #f7f8fa;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

:deep(.van-uploader__wrapper) {
  width: 220px;
  position: relative;
}

:deep(.van-uploader__input) {
  position: absolute;
  left: 0;
  top: 0;
  width: 220px;
  height: 220px;
  opacity: 0;
}

.upload-tip {
  width: 220px;
  text-align: center;
  font-size: 14px;
  color: #666;
  margin-top: 8px;
  font-weight: 500;
}

.proof-desc {
  margin-top: 16px;
  margin-left: 20px;
  font-size: 16px !important;
  color: #666;
  padding: 0;
  border-radius: 0;
  background: transparent;
}

.proof-desc p {
  margin: 14px 0;
  line-height: 1.6;
}

.proof-desc .blue-text {
  color: #3860cf !important;
  font-weight: bold;
}

.proof-desc .red-text {
  color: #e74c3c !important;
  font-weight: bold;
}






// 升级提示弹窗样式
.upgrade-dialog {
  .van-dialog {
    width: 80%;
    max-width: 300px;
    border-radius: 12px;
    overflow: hidden;
  }

  .upgrade-content {
    padding: 20px;
    text-align: center;
    background: linear-gradient(135deg, #fff9f0 0%, #fff 100%);
  }

  .upgrade-icon {
    margin: 10px 0 20px;
    animation: bounce 2s infinite;
  }

  .upgrade-title {
    color: #ff6b00;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 15px;
  }

  .upgrade-message {
    color: #333;
    margin: 8px 0;
    font-size: 15px;
    line-height: 1.5;
  }

  .upgrade-time {
    color: #ff6b00;
    font-weight: bold;
    margin: 15px 0 20px;
    font-size: 14px;
  }

  .upgrade-btn {
    background: linear-gradient(to right, #ff9500, #ff6b00);
    border: none;
    border-radius: 25px;
    height: 44px;
    font-size: 16px;
    font-weight: bold;
    margin-top: 10px;
    box-shadow: 0 4px 8px rgba(255, 107, 0, 0.2);
  }

  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-10px);
    }
    60% {
      transform: translateY(-5px);
    }
  }
}
.package-btns {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 10px;
  display: flex;
  justify-content: center;
  gap: 12px;
  z-index: 999;
}
.pkg-btn {
  min-width: 120px;
  padding: 10px 16px;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  font-size: 14px;
  border-radius: 24px;
  text-align: center;
  text-decoration: none;
}
.pkg-btn:active {
  opacity: 0.8;
}

.zfxqTable3 table,
.zfxqTable3 th,
.zfxqTable3 td {
  border: 1px solid #799ffd;
  padding: 4px;
  border-radius: 0;
}
.zfxqTable3 table {
  border-collapse: separate;
  border-spacing: 0;
}
.zfxqTable3 .zTh {
  color: #3e5fb2;
  text-align: center;
  font-size: 13px;
  font-weight: bold;
  box-sizing: border-box;
  padding: 8px 6px;
  background: #fff;
}
.zfxqTable3 .zTd {
  text-align: center;
  font-size: 13px;
  color: #3e5fb2;
  padding: 8px 6px;
  background: #fff;
}
.zfxqTable3 .zTd.left {
  text-align: left;
  font-size: 12px;
  color: #19191a;
}
.zfxqTable3 .blueText {
  color: #3e5fb2;
  font-weight: bold;
}


.tcBox {
  padding: 10px 0;
  // padding-bottom: 20px;
  .topBox {
    display: flex;
    justify-content: end;
    align-items: center;
    padding: 0 20px;
    .close {
      color: #969799;
      padding: 15px;
    }
    .define {
      color: #576b95;
      padding: 10px;
    }
    .title {
      font-size: 18px;
      padding: 15px;
    }
  }
  .content {
    .tcItem {
      border-bottom: 1px solid #eee;
      padding: 10px 0;
      font-size: 16px;
      text-align: center;
      box-sizing: border-box;
      &:last-child {
        border: none;
      }
      &.active {
        color: #3074da;
      }
    }
  }
}

</style>
